import { Box } from "@chakra-ui/react";

const AdLayout = ({BoxA=Empty, BoxB, BoxC=Empty, ...props}) => {
    return (
        <Box
            flexDir="row"
            alignItems="stretch"
            width="100%"
            display={{base: "block", lg: "flex"}}
            pt="2"
        >

        <Box
            flex="1"
        >
            <BoxA/>
        </Box>

        <Box
            mt="2%"
            flex="3"
            p="4"
        >
            <BoxB/> 
        </Box>

        <Box
            flex="1"
        >
            <BoxC/>
        </Box>

    </Box>

    );
}

const Empty = () => {
    return ""
}

export default AdLayout;